import { useMemo } from 'react';

import { useUserMetadata } from './useUserMetadata';

import type { AssetType } from '@/types/asset';

type DownloadParams =
  | {
      type: AssetType;
      id: number;
    }
  | Record<never, never>;

export const useDownloads = (params: DownloadParams = {}) => {
  const { trackDownloaded, sfxDownloaded, mgDownloaded, svDownloaded } =
    useUserMetadata();

  // Memoize the specific download check to avoid unnecessary recalculations
  const isDownloaded = useMemo(() => {
    if (!('id' in params)) {
      return;
    }

    const { id, type } = params;
    let downloads: number[] | undefined;

    if (type === 'music') {
      downloads = trackDownloaded;
    } else if (type === 'sfx') {
      downloads = sfxDownloaded;
    } else if (type === 'motion') {
      downloads = mgDownloaded;
    } else if (type === 'stock_footage') {
      downloads = svDownloaded;
    }

    return downloads?.includes(id) ?? false;
  }, [trackDownloaded, sfxDownloaded, mgDownloaded, params, svDownloaded]);

  return useMemo(
    () => ({
      trackDownloaded,
      sfxDownloaded,
      mgDownloaded,
      svDownloaded,
      isDownloaded,
    }),
    [trackDownloaded, sfxDownloaded, mgDownloaded, isDownloaded, svDownloaded]
  );
};
